import getLocBySiruta from "./getLocBySiruta";

const ensureArray = (item) => {
    if (!item) return [];
    if (Array.isArray(item)) return item;
    return [item];
};

const getSafeText = (val) => {
    if (typeof val === 'string') return val;
    if (typeof val === 'number') return val;
    return "";
}

const mapContact = (pfWrapper) => {
    // pfWrapper is { PF: { ... } } or just the object if xml2js parsed differently
    // Based on examples: { PF: { ... } }
    const data = pfWrapper.PF || pfWrapper; 
    
    const nume = getSafeText(data.Nume);
    const prenume = getSafeText(data.Prenume);
    const name = [nume, prenume].filter(Boolean).join(" ");

    const domiciliu = data.Domiciliul || data.Resedinta || data.Adresa || {};
    const act = data.ActIdentitate || {};
    const loc = +getSafeText(domiciliu.Localitate)
    const judloc = getLocBySiruta(loc)
    return {
        name: name,
        cnp: getSafeText(data.CNPSolicitant || data.CNP),
        ciSeria: getSafeText(act.Serie),
        ciNr: getSafeText(act.Nr),
        ciElibDe: getSafeText(act.EliberatDe),
        
        domLoc: judloc?.localitate,
        domStr: getSafeText(domiciliu.Strada),
        domNr: getSafeText(domiciliu.Nr),
        domBl: getSafeText(domiciliu.Bloc),
        domSc: getSafeText(domiciliu.Scara),
        domEt: getSafeText(domiciliu.Etaj),
        domAp: getSafeText(domiciliu.Apartament),
        domJud: judloc?.judet,
        domCod: getSafeText(domiciliu.CodPostal),
        domTel: getSafeText(domiciliu.Telefon),
        domEmail: getSafeText(domiciliu.Email),
        domTara: "ROMÂNIA", 
    };
};

const mapContactPJ = (pjData) => {
    const data = pjData || {};
    const sediu = data.Sediul || {};

    
    const loc = +getSafeText(sediu.Localitate)
    const judloc = getLocBySiruta(loc)

    return {
        name: getSafeText(data.Denumire),
        cui: getSafeText(data.CUI_CIF),
        pjRegNr: getSafeText(data.NrOrdineRegCom),
        
        pjLoc: judloc.localitate,
        pjStr: getSafeText(sediu.Strada),
        pjNr: getSafeText(sediu.Nr),
        pjBl: getSafeText(sediu.Bloc),
        pjSc: getSafeText(sediu.Scara),
        pjEt: getSafeText(sediu.Etaj),
        pjAp: getSafeText(sediu.Apartament),
        pjJud: judloc.judet,
        pjCod: getSafeText(sediu.CodPostal),
        pjTel: getSafeText(sediu.Telefon),
        pjFax: getSafeText(sediu.Fax),
        pjEmail: getSafeText(sediu.Email),
        pjSite: getSafeText(sediu.Website),
        pjTara: "ROMÂNIA",
    };
};

const mapPreemptori = (madrData) => {
    const preemptori = [];
    const ranguri = [
        { key: 'Rang_I', id: '1' },
        { key: 'Rang_II', id: '2' },
        { key: 'Rang_III', id: '3' },
        { key: 'Rang_IV', id: '4' },
        { key: 'Rang_V', id: '5' },
        { key: 'Rang_VI', id: '6' },
        { key: 'Rang_VII', id: '7' },
    ];

    if (!madrData.Preemtori) return [];

    ranguri.forEach(r => {
        const rangData = madrData.Preemtori[r.key];
        // Check if chk is 1. Sometimes it might be "1" or 1.
        if (rangData && String(rangData.chk) === "1" && rangData.Detalii) {
            const detalii = ensureArray(rangData.Detalii);
            detalii.forEach(d => {
                const nume = getSafeText(d.Nume);
                if (nume) {
                    preemptori.push({
                        name: nume,
                        rangId: r.id
                    });
                }
            });
        }
    });
    return preemptori;
};

export default function convertFromMadrData(madrData) {
    if (!madrData) return null;
    console.log("madr data:", madrData)
    const ofertanti = [];
    
    if (madrData.Solicitant && madrData.Solicitant.PersoanaFizica) {
        const pfs = ensureArray(madrData.Solicitant.PersoanaFizica);

        pfs.forEach((pf, index) => {
            const pfData = pf.PF || pf; 
            const titular = mapContact(pfData);

            if (!titular.name && !titular.cnp) return;

            const ofertant = {
                tip: true,
                titular: titular
            };
            
            if (index > 0 && String(pfData.chkAcelasiImputernicit) === "1") {
                const previousOfertant = ofertanti[index - 1];
                if (previousOfertant) {
                    ofertant.mandatar = previousOfertant.mandatar || previousOfertant.titular;
                    if (previousOfertant.mandatar) {
                        ofertant.calitate = previousOfertant.calitate;
                        ofertant.conform = previousOfertant.conform;
                    }
                }
            } else if (pfData.Reprezentant && (getSafeText(pfData.Reprezentant.Nume) || getSafeText(pfData.Reprezentant.Prenume))) {
                ofertant.mandatar = mapContact(pfData.Reprezentant);
                ofertant.calitate = getSafeText(pfData.Reprezentant.Calitate);
                ofertant.conform = getSafeText(pfData.Reprezentant.Conform);
            }
            ofertanti.push(ofertant);
        });
    }

    if (madrData.Solicitant && madrData.Solicitant.PJ) {
        const pjs = ensureArray(madrData.Solicitant.PJ);
        pjs.forEach(pj => {
            const solicitantPJ = pj.SolicitantPJ;
            if (solicitantPJ && (getSafeText(solicitantPJ.Denumire) || getSafeText(solicitantPJ.CUI_CIF))) {
                const ofertant = {
                    tip: false,
                    titular: mapContactPJ(solicitantPJ)
                };

                if (pj.Reprezentant && (getSafeText(pj.Reprezentant.Nume) || getSafeText(pj.Reprezentant.Prenume))) {
                    ofertant.mandatar = mapContact(pj.Reprezentant);
                    ofertant.calitate = getSafeText(pj.Reprezentant.Calitate);
                    ofertant.conform = getSafeText(pj.Reprezentant.Conform);
                }
                ofertanti.push(ofertant);
            }
        });
    }
    
    const teren = madrData.ListaTerenuri?.Terenuri || {};
    const declaratii = madrData.Declaratii || {};
    const oferta = madrData.OfertaPF || {};
    const detalii = madrData.OfertaDetalii || {};

    let terenLoc = getSafeText(madrData.ListaTerenuri?.Comuna);
   const judloc = getLocBySiruta(terenLoc)

    
    console.log("tl:", judloc)
    
    const anexe = {
        preemptoriCerere: mapPreemptori(madrData),
        documenteCerere: [],
        sarcini: String(declaratii.EsteGrevatDeSarcini) === "1",
        litigii: String(declaratii.AreLitigii) === "1",
        
        terenHa: getSafeText(teren.Suprafata),
        terenLoc: getSafeText(judloc.localitate?.toUpperCase()),
       terenJud: getSafeText(judloc.judet?.toUpperCase()),
        terenNrCadastral: getSafeText(teren.NrCadastral),
        terenCf: getSafeText(teren.NrCarteFunciara),
        terenCfLoc: getSafeText(declaratii.Localitate || terenLoc),
        terenTarlaLot: getSafeText(teren.Tarla),
        terenParcela: getSafeText(teren.Parcela),
        terenCategorie: getSafeText(teren.Categorie),
        terenObs: getSafeText(teren.Observatii),
        terenPret: getSafeText(oferta.PretOfertaVanzare),
        terenConditii: getSafeText(detalii.Conditii),
        cotaParte: getSafeText(oferta.CotaParte) || "1/1",
    };

    if (madrData.listaDocumente?.altedocumente?.document) {
        const docs = ensureArray(madrData.listaDocumente.altedocumente.document);
        docs.forEach(d => {
            if (String(d.Bifa) === "1" && d.Descriere) {
                anexe.documenteCerere.push(d.Descriere);
            }
        });
    }

    return {
        tip: madrData.general.Tip_operator == "1" ? "pf" : "pj",
        anexe,
        ofertanti
    };
}